import { API_ENDPOINT } from './config';

export const urlsExternal = {
  // External partners
  externalPartners: (approvedOnly) =>
    approvedOnly
      ? `${API_ENDPOINT}/external/partners/?approvedOnly=true`
      : `${API_ENDPOINT}/external/partners`,
  externalPartnerCreate: `${API_ENDPOINT}/external/partners`,
  externalPartnerApprove: (id) =>
    `${API_ENDPOINT}/external/partners/approve/${id}`,
  externalPartnerDeactivate: (id) =>
    `${API_ENDPOINT}/external/partners/deactivate/${id}`,
  externalPartnerDetail: (id) => `${API_ENDPOINT}/external/partners/${id}`,
  externalPartnerDelete: (id) => `${API_ENDPOINT}/external/partners/${id}`,

  // External users
  externalUsers: `${API_ENDPOINT}/external/users`,
  externalUserCreate: `${API_ENDPOINT}/external/users`,
  externalUserActivate: (id) => `${API_ENDPOINT}/external/users/activate/${id}`,
  externalUserDeactivate: (id) =>
    `${API_ENDPOINT}/external/users/deactivate/${id}`,
  externalUserDetail: (id) => `${API_ENDPOINT}/external/users/${id}`,
  externalUserDelete: (id) => `${API_ENDPOINT}/external/users/${id}`,
  externalUserDeleteSelf: `${API_ENDPOINT}/external/users/self/delete`,

  // Password reset
  validateToken: `${API_ENDPOINT}/external/validate-token`,
  passwordReset: `${API_ENDPOINT}/external/password-reset`,
  passwordResetSubmit: `${API_ENDPOINT}/external/password-reset-submit`,
};

export const routesExternal = {
  // Public
  forgottenPassword: `/zabudnute-heslo`,
  passwordReset: (token) => `/zmena-hesla/${token}`,
  externalPartnerRegistration: '/registracia-externeho-partnera-fri',
  externalUserRegistration: '/registracia-externeho-pouzivatela',

  // CMS
  cmsExternalUsers: '/cms/external/users',
  cmsExternalUsersCreate: '/cms/external/users/create',
  cmsExternalUsersEdit: (id) => `/cms/external/users/edit/${id}`,
  cmsExternalPartners: '/cms/external/partners',
  cmsExternalPartnersCreate: '/cms/external/partners/create',
  cmsExternalPartnersEdit: (id) => `/cms/external/partners/edit/${id}`,
};
